import { Select } from "@mui/material";
import { allPortalWidgetStatuses, type PortalWidgetStatus } from "@entrilia/shared/api/portalWidgetsTypes";
import MenuItemWithoutHighlight from "@entrilia/shared/components/MenuItemWithoutHighlight";
import PortalWidgetStatusTag from "./PortalWidgetStatusTag";

interface Props {
  value: PortalWidgetStatus;
  availableStatuses: PortalWidgetStatus[];
  disabled?: boolean;
  onChange: (newValue: PortalWidgetStatus) => void;
}

const PortalWidgetStatusSelect = ({ value, availableStatuses, disabled, onChange }: Props) => {
  return (
    <Select<PortalWidgetStatus>
      variant="standard"
      disableUnderline
      disabled={disabled}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      sx={{
        ".MuiInputBase-input": {
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      }}
    >
      {allPortalWidgetStatuses.map((status) => (
        <MenuItemWithoutHighlight key={status} value={status} disabled={!availableStatuses.includes(status)}>
          <PortalWidgetStatusTag status={status} />
        </MenuItemWithoutHighlight>
      ))}
    </Select>
  );
};

export default PortalWidgetStatusSelect;
